import { CalendarDays, Hash, ListChecks, Tag, ToggleLeft } from "lucide-react";
import type { FilterFieldDef } from "@/lib/useFieldFilters";

/** The small icon that tells what kind of field it is (as in HubSpot's picker): Abc text, # number, calendar date, list of choices, tags, yes/no */
export function FieldTypeIcon({ type }: { type: FilterFieldDef["type"] }) {
  const cls = "size-4 shrink-0 text-muted-foreground";
  if (type === "number") return <Hash className={cls} />;
  if (type === "date") return <CalendarDays className={cls} />;
  if (type === "enum") return <ListChecks className={cls} />;
  if (type === "tags") return <Tag className={cls} />;
  if (type === "boolean") return <ToggleLeft className={cls} />;
  return <span aria-hidden="true" className="w-4 shrink-0 text-center text-[10px] font-semibold leading-none text-muted-foreground">Abc</span>;
}
